import { NgModule } from '@angular/core';
import { AppComponent } from './layout/app.component';
import { BrowserModule } from '@angular/platform-browser';
import {
  NgxUiLoaderModule,
  NgxUiLoaderRouterModule,
  NgxUiLoaderHttpModule,
  NgxUiLoaderConfig,
  POSITION,
  SPINNER,
} from 'ngx-ui-loader';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AppConfig } from './config/config';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
  provideHttpClient,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AdvancedMapComponent } from './components/advanced-map/advanced-map.component';
import { NetworkAssetComponent } from './components/network-asset/network-asset.component';
import { CustomerComponent } from './components/customer/customer.component';
import { CardComponent } from './components/card/card.component';
import { FilterComponent } from './components/filter/filter.component';
import { MeterManagementComponent } from './components/meter-management/meter-management.component';
import { ReadingsComponent } from './components/readings/readings.component';
import { AiComponent } from './components/ai/ai.component';
import { EditMvPoleComponent } from './components/mv-pole/edit-mv-pole/edit-mv-pole.component';
import { MvPoleListComponent } from './components/mv-pole/mv-pole-list/mv-pole-list.component';
import { MvPoleLayoutComponent } from './components/mv-pole/mv-pole-layout/mv-pole-layout.component';
import { DetailSidebarComponent } from './components/detail-sidebar/detail-sidebar.component';
import { DetailSidebarLayoutComponent } from './components/detail-sidebar-layout/detail-sidebar-layout.component';
import { AssetListHeaderComponent } from './components/asset-list-header/asset-list-header.component';
import { AssetListPaginationComponent } from './components/asset-list-pagination/asset-list-pagination.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpInterceptorService } from '../app/helpers/interceptor/interceptor';
import { ImageSectionComponent } from './components/common/image-section/image-section.component';
import { SharedModule } from './shared/_services/shared.module';
import { MvPoleFilterWindowComponent } from './components/filter-window/mv-pole-filter-window/mv-pole-filter-window.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { AssetMapComponent } from './components/asset-map/asset-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { AssignTaskModalComponent } from './components/common/assign-task-modal/assign-task-modal.component';
import { AuditReviewComponent } from './components/common/audit-review/audit-review.component';
import { HistoryTrackerComponent } from './components/common/history-tracker/history-tracker.component';
import { HistoryComponent } from './components/history/history/history.component';
import { DataQualityComponent } from './components/common/data-quality/data-quality.component';
import { MultiSelectDropdownComponent } from './components/common/multi-select-dropdown/multi-select-dropdown.component';
import { FilterChecklistComponent } from './components/common/filter-checklist/filter-checklist.component';
import { CrudComponent } from './components/crud/crud.component';
import { CrudSidebarComponent } from './components/crud/crud-sidebar/crud-sidebar.component';
import { NetworkAssetSidebarComponent } from './components/network-asset/network-asset-sidebar/network-asset-sidebar.component';
import { AddNewNetworkDeviceFieldComponent } from './components/crud/crud-section-definitions/add-new-network-device-field/add-new-network-device-field.component';
import { CrudSectionDefinitionsComponent } from './components/crud/crud-section-definitions/crud-section-definitions.component';
import { AddNewSectionDefinitionComponent } from './components/crud/crud-section-definitions/add-new-section-definition/add-new-section-definition.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ShowMoreComponent } from './components/common/show-more/show-more.component';
import { OverviewCardComponent } from './components/common/overview-card/overview-card.component';
import { OverviewDetailCardComponent } from './components/common/overview-detail-card/overview-detail-card.component';
import { ReorderSectionDefinitionComponent } from './components/crud/crud-section-definitions/reorder-section-definition/reorder-section-definition.component';
import { CrudTsComponent } from './components/crud/crud-ts/crud-ts.component';
import { CrudF33Component } from './components/crud/crud-f33/crud-f33.component';
import { CrudF11Component } from './components/crud/crud-f11/crud-f11.component';
import { CrudDtComponent } from './components/crud/crud-dt/crud-dt.component';
import { CrudDistrictComponent } from './components/crud/crud-district/crud-district.component';
import { CrudFilterComponent } from './components/crud/crud-filter/crud-filter.component';
import { CrudSsComponent } from './components/crud/crud-is/crud-ss.component';
import { CrudRegionComponent } from './components/crud/crud-region/crud-region.component';
import { CrudTariffComponent } from './components/crud/crud-tariff/crud-tariff.component';
import { CrudMeterTypeComponent } from './components/crud/crud-meter-type/crud-meter-type.component';
import { CrudAssetRatingComponent } from './components/crud/crud-asset-rating/crud-asset-rating.component';
import { AdvancedMapFilterComponent } from './components/advanced-map/advanced-map-filter/advanced-map-filter.component';
import { AdvancedMapPinComponent } from './components/advanced-map/advanced-map-pin/advanced-map-pin.component';
import { MapInfoWindowComponent } from './components/advanced-map/map-info-window/map-info-window.component';
import { AdvSwitchButtonsComponent } from './components/advanced-map/adv-switch-buttons/adv-switch-buttons.component';
import { NetworkAssetsComponent } from './components/network-assets/network-assets.component';
import { VflowChartComponent } from './components/common/vflow-chart/vflow-chart.component';
import { NetworkAssetsMoreOptionsComponent } from './components/network-assets/network-assets-more-options/network-assets-more-options.component';
import { PagingComponent } from './components/paging/paging.component';
import { SingleSelectDropdownComponent } from './components/common/single-select-dropdown/single-select-dropdown.component';
import { BcMapFullDetailsComponent } from './components/advanced-map/adv-map-full-details/bc-map-full-details/bc-map-full-details.component';
import { DtMapFullDetailsComponent } from './components/advanced-map/adv-map-full-details/dt-map-full-details/dt-map-full-details.component';
import { PoleMapFullDetailsComponent } from './components/advanced-map/adv-map-full-details/pole-map-full-details/pole-map-full-details.component';
import { CrudCustomerAccountsComponent } from './components/crud/crud-customer-accounts/crud-customer-accounts.component';
import { CrudEditCustomerComponent } from './components/crud/crud-customer-accounts/crud-edit-customer/crud-edit-customer.component';
import { AuditReviewCustomerComponent } from './components/audit-review-customer/audit-review-customer.component';
import { ReviewComponent } from './components/review/review.component';
import { AddNewCustomerAccountComponent } from './components/crud/crud-customer-accounts/add-new-customer-account/add-new-customer-account.component';
import { CustomerCrudFilterWindowComponent } from './components/filter-window/customer-crud-filter-window/customer-crud-filter-window.component';
import { NgChartsModule } from 'ng2-charts';
import { SearchMapComponentComponent } from './components/advanced-map/search-map-component/search-map-component.component';
import { DatePipe } from '@angular/common';
import { SearchDropdownComponent } from './components/advanced-map/search-map-component/search-dropdown/search-dropdown.component';
import { environment } from '../environments/environment';
import { SubstationListComponent } from './components/asset-list/substations/substation-list/substation-list.component';
import { SubstationFilterWindowComponent } from './components/filter-window/substation-filter-window/substation-filter-window.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { TooltipService } from './services/tooltip.service';
import { EditInjectionSubstationComponent } from './components/asset-list/substations/edit-injection-substation/edit-injection-substation.component';
import { SlideToggleDirective } from './directives/slidetoggle.directive';
import { MapLayoutComponent } from './components/map-layout/map-layout.component';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';
import { SectionInstanceColumnComponent } from './components/common/section-instance-column/section-instance-column.component';
import { SectionInstanceCardComponent } from './components/common/section-instance/section-instance-card/section-instance-card.component';
import { DropdownSearchComponent } from './components/common/dropdown-search/dropdown-search.component';
import { CrudMultiSelectDropdownSearchComponent } from './components/common/crud-multi-select-dropdown-search/crud-multi-select-dropdown-search.component';
import { AttributeValueRowComponent } from './components/common/section-instance/attribute-rows/attribute-value-row/attribute-value-row.component';
import { AttributeLocationRowComponent } from './components/common/section-instance/attribute-rows/attribute-location-row/attribute-location-row.component';
import { AttributeImageRowComponent } from './components/common/section-instance/attribute-rows/attribute-image-row/attribute-image-row.component';
import { AttributeSelectedOptionsRowComponent } from './components/common/section-instance/attribute-selected-options-row/attribute-selected-options-row.component';
import { AttributeFileRowComponent } from './components/common/section-instance/attribute-rows/attribute-file-row/attribute-file-row.component';
import { BpsAdminDashboardComponent } from './components/bps-admin/bps-admin-dashboard/bps-admin-dashboard.component';
import { BpsAdminJobHistoryComponent } from './components/bps-admin/bps-admin-job-history/bps-admin-job-history.component';
import { AuditLogComponent } from './components/bps-admin/audit-log/audit-log/audit-log.component';
import { UtilityAssetAndCustomerEntitiesComponent } from './components/bps-admin/utility-asset-and-customer-entities/utility-asset-and-customer-entities.component';
import { UtilityManagementComponent } from './components/bps-admin/utility-management/utility-management/utility-management.component';
import { DeploymentStatusPipe } from './pipes/deployment-status.pipe';
import { WorkflowConfigurationComponent } from './components/workflow-configuration/workflow-configuration.component';
import { WorkflowCardComponent } from './components/workflow-configuration/workflow-card/workflow-card.component';
import { AddUtilityComponent } from './components/bps-admin/utility-management/add-utility/add-utility.component';
import { UtilityHeaderComponent } from './components/bps-admin/utility-management/utility-header/utility-header.component';
import { AddNewModuleComponent } from './components/workflow-configuration/add-new-module/add-new-module.component';
import { CustomFileInputComponent } from './components/workflow-configuration/custom-file-input/custom-file-input.component';
import { ColorSketchModule } from 'ngx-color/sketch'
import { IconModalContentComponent } from './components/workflow-configuration/add-new-module/icon-modal-content/icon-modal-content.component';
import { ToggleFieldComponent } from './components/common/toggle-field/toggle-field.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MapConfigurationComponent } from './components/bps-admin/utility-management/map-configuration/map-configuration.component';
import { RoleAndPermissionsComponent } from './components/role-and-permissions/role-and-permissions.component';
import { RoleAndPermissionsSidebarComponent } from './components/role-and-permissions/role-and-permissions-sidebar/role-and-permissions-sidebar.component';
import { EntityModelCustomizationComponent } from './components/entity-model-customization/entity-model-customization.component';
import { EmcRecallComponent } from './components/entity-model-customization/dynamic/emc-recall/emc-recall.component';
import { EmcRetagComponent } from './components/entity-model-customization/dynamic/emc-retag/emc-retag.component';
import { EmcAssetComponent } from './components/entity-model-customization/assets/emc-asset/emc-asset.component';
import { PreviewSchematicDiagramComponent } from './components/bps-admin/utility-management/preview-schematic-diagram/preview-schematic-diagram.component';
import { EnumDropdownComponent } from './components/common/enum-dropdown/enum-dropdown.component';
import { IconColorComponent } from './components/common/icon-color/icon-color.component';
import { FilterDynamicComponent } from './components/filter-dynamic/filter-dynamic.component';
import { ObjectDropdownComponent } from './components/common/object-dropdown/object-dropdown.component';
import { DynamicSubstationListComponent } from './components/dynamic-asset-list/dynamic-substation-list/dynamic-substation-list.component';
import { DynamicCardsComponent } from './components/entity-model-customization/dynamic-cards/dynamic-cards.component';
import { DynamicFilterWindowComponent } from './components/dynamic-filter-window/dynamic-filter-window.component';
import { EmcSearchComponentComponent } from './components/common/emc-search-component/emc-search-component.component';
import { GeneratedObjectRepresentationComponent } from './components/common/generated-object-representation/generated-object-representation.component';
import { PaginationNewComponent } from './components/pagination-new/pagination-new.component';
import { ArrowTooltipDirective } from './directives/arrow-tooltip.directive';
import { SettingsSidenavComponent } from './components/sidenavs/settings-sidenav/settings-sidenav.component';
import { TimeAgoPipe } from "./pipes/time-ago.pipe";

import { SharedLibModule } from 'shared-lib';
import { SHARED_LIB_CONFIG } from 'shared-lib'
import { AssetListSidenavComponent } from './components/sidenavs/asset-list-sidenav/asset-list-sidenav.component';
import { AdvMapPreviewModal } from './components/entity-model-customization/assets/emc-asset/adv-map-preview-modal/adv-map-preview-modal';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsPosition: POSITION.centerCenter,
  bgsColor: 'var(--primary-color)',
  fgsColor: 'var(--primary-color)',
  overlayColor: 'transparent',
  bgsOpacity: 0.85,
  bgsSize: 70,
  fgsSize: 70,
  fgsType: SPINNER.rectangleBounce,
  bgsType: SPINNER.rectangleBounce,
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    SidebarComponent,
    AdvancedMapComponent,
    NetworkAssetComponent,
    CustomerComponent,
    CardComponent,
    MeterManagementComponent,
    ReadingsComponent,
    AiComponent,
    FilterComponent,
    EditMvPoleComponent,
    MvPoleListComponent,
    MvPoleLayoutComponent,
    DetailSidebarComponent,
    AssetListHeaderComponent,
    DetailSidebarLayoutComponent,
    AssetListPaginationComponent,
    ImageSectionComponent,
    AssetMapComponent,
    AssignTaskModalComponent,
    AuditReviewComponent,
    HistoryTrackerComponent,
    HistoryComponent,
    DataQualityComponent,
    MultiSelectDropdownComponent,
    CrudComponent,
    FilterChecklistComponent,
    NetworkAssetSidebarComponent,
    CrudSidebarComponent,
    AddNewNetworkDeviceFieldComponent,
    MvPoleFilterWindowComponent,
    AddNewSectionDefinitionComponent,
    CrudSectionDefinitionsComponent,
    ShowMoreComponent,
    OverviewCardComponent,
    OverviewDetailCardComponent,
    ReorderSectionDefinitionComponent,
    CrudFilterComponent,
    CrudTsComponent,
    CrudF33Component,
    CrudF11Component,
    CrudSsComponent,
    CrudComponent,
    CrudDtComponent,
    CrudDistrictComponent,
    CrudRegionComponent,
    CrudTariffComponent,
    CrudCustomerAccountsComponent,
    CrudMeterTypeComponent,
    CrudAssetRatingComponent,
    AdvancedMapFilterComponent,
    AdvSwitchButtonsComponent,
    AdvancedMapPinComponent,
    NetworkAssetsComponent,
    NetworkAssetsMoreOptionsComponent,
    PagingComponent,
    SingleSelectDropdownComponent,
    BcMapFullDetailsComponent,
    DtMapFullDetailsComponent,
    PoleMapFullDetailsComponent,
    CrudEditCustomerComponent,
    // AuditReviewComponent,
    AuditReviewCustomerComponent,
    ReviewComponent,
    CrudCustomerAccountsComponent,
    AddNewCustomerAccountComponent,
    CustomerCrudFilterWindowComponent,
    SearchMapComponentComponent,
    SearchDropdownComponent,
    SubstationListComponent,
    SubstationFilterWindowComponent,
    SlideToggleDirective,
    TooltipDirective,
    MapLayoutComponent,
    DoughnutChartComponent,
    EditInjectionSubstationComponent,
    SectionInstanceColumnComponent,
    SectionInstanceCardComponent,
    DropdownSearchComponent,
    CrudMultiSelectDropdownSearchComponent,
    AttributeValueRowComponent,
    AttributeLocationRowComponent,
    AttributeImageRowComponent,
    AttributeSelectedOptionsRowComponent,
    AttributeFileRowComponent,
    BpsAdminDashboardComponent,
    BpsAdminJobHistoryComponent,
    AuditLogComponent,
    UtilityAssetAndCustomerEntitiesComponent,
    UtilityManagementComponent,
    WorkflowConfigurationComponent,
    WorkflowCardComponent,
    AddUtilityComponent,
    UtilityHeaderComponent,
    AddNewModuleComponent,
    CustomFileInputComponent,
    IconModalContentComponent,
    ToggleFieldComponent,
    MapConfigurationComponent,
    RoleAndPermissionsComponent,
    RoleAndPermissionsSidebarComponent,
    EntityModelCustomizationComponent,
    EmcRecallComponent,
    EmcRetagComponent,
    EmcAssetComponent,
    PreviewSchematicDiagramComponent,
    EnumDropdownComponent,
    IconColorComponent,
    EmcAssetComponent,
    FilterDynamicComponent,
    DynamicSubstationListComponent,
    DynamicCardsComponent,
    DynamicFilterWindowComponent,
    FilterDynamicComponent,
    ObjectDropdownComponent,
    EmcSearchComponentComponent,
    GeneratedObjectRepresentationComponent,
    PaginationNewComponent,
    SettingsSidenavComponent,
    NetworkAssetComponent,
    AssetListSidenavComponent,
    AdvMapPreviewModal,
  ],
  imports: [
    SharedLibModule,
    AppRoutingModule,
    BrowserModule,
    NgbModule,
    HttpClientModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule.forRoot({ showForeground: true }),
    NgxUiLoaderHttpModule.forRoot({
        showForeground: true,
    }),
    NgxUiLoaderHttpModule.forRoot({
        exclude: [
            environment['pathApi'] + 'advancedMap/getBuildingsCount',
            environment['pathApi'] + 'advancedMap/getCustomersCount',
            environment['pathApi'] + 'advancedMap/getDtsCount',
            environment['pathApi'] + 'advancedMap/getPolesCount',
            environment['pathApi'] + 'substation/getStatsDynamic',
            environment['pathApi'] + 'Schematic/save',
            environment['pathApi'] + 'Schematic/getBySubstationId',
            environment['pathApi'] + 'chat/send',
            environment['pathApi'] + 'chat/start',
        ],
        showForeground: true,
    }),
    RouterModule.forRoot([]),
    FormsModule,
    VflowChartComponent,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    }),
    SharedModule,
    NgxImageZoomModule,
    GoogleMapsModule,
    DragDropModule,
    MapInfoWindowComponent,
    NgChartsModule,
    DeploymentStatusPipe,
    ColorSketchModule,
    ArrowTooltipDirective,
    TimeAgoPipe
],
  providers: [
    AppConfig,
    TooltipService,
    DatePipe,
    provideHttpClient(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: SHARED_LIB_CONFIG,
      useValue: { pathApi: environment.pathApi }
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  // constructor(private analytics: AngularFireAnalytics) {
  //   if (environment.production) {
  //     this.analytics.setAnalyticsCollectionEnabled(true);
  //   } else {
  //     this.analytics.setAnalyticsCollectionEnabled(false);
  //   }
  // }
}
